var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialGooglePlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.547,
    height: 40.547
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 2003",
    d: "M0 0h40.547v40.547H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 22752",
    d: "M29.222 20.48a10.6 10.6 0 00-.145-1.73h-8.611v3.437h4.931a4.245 4.245 0 01-1.827 2.724v2.29h2.942a8.941 8.941 0 002.71-6.721z",
    fill: "#4285f4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 22753",
    d: "M20.47 29.419a8.711 8.711 0 006.043-2.218l-2.943-2.286a5.517 5.517 0 01-3.1.884 5.461 5.461 0 01-5.129-3.78h-3.033v2.355a9.131 9.131 0 008.162 5.045z",
    fill: "#34a853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 22754",
    d: "M15.339 22.015a5.307 5.307 0 01-.29-1.745 5.513 5.513 0 01.29-1.745v-2.351h-3.033a9.039 9.039 0 00-.983 4.1 9.039 9.039 0 00.983 4.1z",
    fill: "#fbbc05"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 22755",
    d: "M20.47 14.749a4.962 4.962 0 013.5 1.372l2.606-2.606a8.743 8.743 0 00-6.106-2.386 9.131 9.131 0 00-8.162 5.045l3.033 2.355a5.461 5.461 0 015.129-3.78z",
    fill: "#ea4335"
  })));
}
export default SvgSocialGooglePlus;